import { BoardConfig } from '../react-chart-board/board-config';
import { MenuConfiguration } from '../react-sidebar/class/menu-configuration';

export class ChartBoardDemoConfig {
    constructor(public grid: BoardConfig, public menuConfiguration: MenuConfiguration) {
    }
}
